import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/agricultura/praga-doenca' };
/////////////////////////////////////////////////////////////////////////////////

export function createPragaDoenca(payload) {
  return httpService.post({ ...args}, payload);
}

export function updatePragaDoenca(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listPragaDoenca(param) {
  return httpService.get({...args, args: param});
}

export function findPragaDoenca(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllPragaDoenca() {
  return httpService.get({ ...args, path: '/' });
}

export function deletePragaDoenca(id) {
  return httpService.del({ ...args, args: `/${id}` });
}